import { InfoItem } from 'components/molecules/InfoItem/InfoItem';
import { CompanyPageCompanyFragment } from 'generated/graphql';
import { useState } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import {
  HIRING_TEAM_MEMBER_ADDED_EMAIL_LABEL,
  ROLE_LIVE_EMAIL_LABEL,
} from './NotificationsSection.constants';
import NotificationsSectionForm from './NotificationsSectionForm';
import styles from './NotificationsSection.module.scss';

type NotificationsSectionProps = {
  company: CompanyPageCompanyFragment;
};

const NotificationsSection = ({ company }: NotificationsSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  return isEditing ? (
    <NotificationsSectionForm
      company={company}
      onCancelClick={handleCancelClick}
      onSave={handleSave}
    />
  ) : (
    <NotificationsSectionView company={company} onEditClick={handleEditClick} />
  );
};

const NotificationsSectionView = ({
  company,
  onEditClick,
}: {
  company: CompanyPageCompanyFragment;
  onEditClick: () => void;
}) => (
  <div className={styles.viewContainer}>
    <div className={styles.header}>
      <h3 className={styles.title}>Notifications</h3>
      <Button variant="secondary" size="medium" onClick={onEditClick}>
        Edit
      </Button>
    </div>
    <div className={styles.content}>
      <InfoItem
        label={ROLE_LIVE_EMAIL_LABEL}
        value={company.isRoleLiveEmailEnabled ? 'Enabled' : 'Disabled'}
      />
      <InfoItem
        label={HIRING_TEAM_MEMBER_ADDED_EMAIL_LABEL}
        value={
          company.isHiringTeamMemberAddedEmailEnabled ? 'Enabled' : 'Disabled'
        }
      />
    </div>
  </div>
);

export default NotificationsSection;
